export default {
    state: {
        settings: [],
    },
    mutations: {
        setSettings(state, settings) {
            state.settings = settings
        },
        updateSetting(state, setting) {
            const index = state.settings.findIndex(item => item.id === setting.id)
            Vue.set(state.settings, index, setting)
        },
    },
    getters: {
        settings: state => state.settings,
        settingByKey: state => key => state.settings.find(item => item.key === key)
    },
    actions: {
        loadSettings(context) {
            return window.axios.get('/api/settings/settings')
                .then(({data}) => {
                    context.commit('setSettings', data)
                })
                .catch(error => console.error(error))
        },
        updateSetting(context, payload) {
            context.commit('updateSetting', payload)
        },
    }
}
